<div class="container-fluid main-card">
    <div class="row">
        <div class="col-12">
            <h1>
                Mes préférences
                <span>Paramétrez les valeurs par défaut de vos futures simulations</span>
            </h1>
        </div>
        <div class="col-lg-12">
            <div class="row">
                <div class="colWidget col-xl-4 col-lg-6"
                     [stepContent]="userDefaultStepContent"
                     [joyrideStep]="'userDefaultStep'">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card block">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h2>Valeurs par défaut</h2>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <div class="col-md-6">
                                            <mat-label class="fs-8">Gestion en agence : <span
                                                class="fs-6">{{ user.agence }}%</span></mat-label>
                                            <mat-slider
                                                thumbLabel
                                                [displayWith]="commonService.percentLabel"
                                                tickInterval="1"
                                                step="0.5"
                                                min="0"
                                                [(ngModel)]="user.agence"
                                                (ngModelChange)="edit($event)"
                                                max="12"></mat-slider>
                                            <mat-hint class="slider">Taux moyen : 7%</mat-hint>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-label class="fs-8">Garantie loyers impayés
                                                : <span class="fs-6">{{ user.amount_rent_insurance }}
                                                    %</span>
                                            </mat-label>
                                            <mat-slider
                                                thumbLabel
                                                [displayWith]="commonService.percentLabel"
                                                tickInterval="1"
                                                step="0.5"
                                                min="0"
                                                [(ngModel)]="user.amount_rent_insurance"
                                                (ngModelChange)="edit($event)"
                                                max="5"></mat-slider>
                                            <mat-hint class="slider">Taux moyen : 3%</mat-hint>
                                        </div>
                                        <div class="col-md-12">
                                            <h4>Travaux</h4>
                                        </div>

                                        <div class="col-md-4">
                                            <mat-form-field>
                                                <mat-label>Rafraichissement</mat-label>
                                                <input matInput [(ngModel)]="user.work_1"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€/m²</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                                <mat-label>Rénovation</mat-label>
                                                <input matInput [(ngModel)]="user.work_2"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€/m²</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                                <mat-label>Remise a neuf</mat-label>
                                                <input matInput [(ngModel)]="user.work_3"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€/m²</span>
                                                <mat-hint><br/></mat-hint>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-md-12">
                                            <h4>Autre frais</h4>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                                <mat-label>PNO</mat-label>
                                                <input matInput [(ngModel)]="user.building_insurance"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€/lots</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                                <mat-label>Comptable</mat-label>
                                                <input matInput [(ngModel)]="user.accouting_fees"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€</span>
                                                <mat-hint><br/></mat-hint>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                                <mat-label>CFE</mat-label>
                                                <input matInput [(ngModel)]="user.cfe_contribution"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€</span>
                                                <mat-hint><br/></mat-hint>
                                            </mat-form-field>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="colWidget col-xl-4 col-lg-6"
                     [stepContent]="userFinanceStepContent"
                     [joyrideStep]="'userFinanceStep'">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card block">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h2>Financement</h2>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Apport</mat-label>
                                                <mat-select disableOptionCentering [(ngModel)]="user.apport_notary"
                                                            (ngModelChange)="edit($event)">
                                                    <mat-option [value]="1">Frais de notaire
                                                    </mat-option>
                                                    <mat-option [value]="0">Montant fixe</mat-option>
                                                    <mat-option [value]="2">Pourcentage</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field
                                                            [hidden]="user.apport_notary == 1">
                                                <mat-label>Montant apport</mat-label>
                                                <input matInput [(ngModel)]="user.apport"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix *ngIf="user.apport_notary == 0">€</span>
                                                <span matSuffix *ngIf="user.apport_notary == 2">%</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input matInput [(ngModel)]="user.duration"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>ans</span>
                                                <mat-hint><br/></mat-hint>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Taux du crédit</mat-label>
                                                <input matInput [(ngModel)]="user.rate"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>%</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-4">
                                            <mat-form-field>
                                                <mat-label>Taux assurance</mat-label>
                                                <input matInput [(ngModel)]="user.rate_insurance"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>%</span>
                                                <mat-hint><br/></mat-hint>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                                <mat-label>Frais bancaire</mat-label>
                                                <input matInput [(ngModel)]="user.banking_fees"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-4">
                                            <mat-form-field>
                                                <mat-label>Frais de cautionnement<i class="fa fa-info-circle"
                                                                                    matTooltip="Montant des frais demandés par votre organisme de cautionnement (Crédit logement, SACCEF, CMH ...) ou les frais d’hypothèque."></i>
                                                </mat-label>
                                                <input matInput [(ngModel)]="user.deposit_fees"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix>€/m²</span>
                                                <mat-hint><br/></mat-hint>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="colWidget  col-xl-4 col-lg-12"
                     [stepContent]="userFiscaStepContent"
                     [joyrideStep]="'userFiscaStep'">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card block">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h2>Votre situation</h2>
                                    </div>
                                </div>
                                <div class="card-body col-md-12">
                                    <div class="card-text row">
                                        <div class="col-md-12">
                                            <mat-form-field>
                                                <mat-label>Choix du régime fiscal</mat-label>
                                                <mat-select disableOptionCentering [(ngModel)]="user.fiscal_choice"
                                                            (ngModelChange)="editFiscal($event)">
                                                    <mat-option value="Foncier forfait">
                                                        Foncier au forfait
                                                    </mat-option>
                                                    <mat-option value="Foncier reel">
                                                        Foncier au réel
                                                    </mat-option>
                                                    <mat-option value="LMNP forfait">
                                                        LMNP au forfait
                                                    </mat-option>
                                                    <mat-option value="LMNP reel">
                                                        LMNP au réel
                                                    </mat-option>
                                                    <mat-option value="SCI IS">
                                                        SCI à l'IS
                                                    </mat-option>
                                                    <mat-option value="SCI IR">
                                                        SCI à l'IR
                                                    </mat-option>
                                                </mat-select>
                                                <mat-hint *ngIf="user.fiscal_choice == ''"
                                                          class="text-red">
                                                    Veuillez renseigner une valeur
                                                </mat-hint>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Nombre de part(s)</mat-label>
                                                <mat-select disableOptionCentering [(ngModel)]="user.shares_number"
                                                            (ngModelChange)="edit($event)">
                                                    <mat-option [value]="1">1</mat-option>
                                                    <mat-option [value]="1.25">1.25</mat-option>
                                                    <mat-option [value]="1.5">1.5</mat-option>
                                                    <mat-option [value]="1.75">1.75</mat-option>
                                                    <mat-option [value]="2">2</mat-option>
                                                    <mat-option [value]="2.25">2.25</mat-option>
                                                    <mat-option [value]="2.5">2.5</mat-option>
                                                    <mat-option [value]="2.75">2.75</mat-option>
                                                    <mat-option [value]="3">3</mat-option>
                                                    <mat-option [value]="3.25">3.25</mat-option>
                                                    <mat-option [value]="3.5">3.5</mat-option>
                                                    <mat-option [value]="3.75">3.75</mat-option>
                                                    <mat-option [value]="4">4</mat-option>
                                                    <mat-option [value]="4.25">4.25</mat-option>
                                                    <mat-option [value]="4.5">4.5</mat-option>
                                                    <mat-option [value]="4.75">4.74</mat-option>
                                                    <mat-option [value]="5">5</mat-option>
                                                    <mat-option [value]="5.25">5.25</mat-option>
                                                    <mat-option [value]="5.5">5.5</mat-option>
                                                    <mat-option [value]="5.75">5.75</mat-option>
                                                    <mat-option [value]="6">6</mat-option>
                                                    <mat-option [value]="6.25">6.25</mat-option>
                                                    <mat-option [value]="6.5">6.5</mat-option>
                                                    <mat-option [value]="6.75">6.75</mat-option>
                                                    <mat-option [value]="7">7</mat-option>
                                                    <mat-option [value]="8">8</mat-option>
                                                    <mat-option [value]="9">9</mat-option>
                                                    <mat-option [value]="10">10</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Net imposable</mat-label>
                                                <input matInput [(ngModel)]="user.annual_income"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> €</span>
                                                <mat-hint>(Avec foncier actuel)</mat-hint>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-12">
                                            <mat-form-field>
                                                <mat-label>Revenus annuel SCI</mat-label>
                                                <input matInput [(ngModel)]="user.annual_income_sci"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> €</span>
                                                <mat-hint>Revenus de votre SCI (optionnel)</mat-hint>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="colWidget col-md-12"
                     [stepContent]="userAmmortStepContent"
                     [joyrideStep]="'userAmmortStep'">
                    <div class="card block">
                        <div class="card-header">
                            <div class="card-title">
                                <h2>Amortissement</h2>
                            </div>
                        </div>
                        <div class="card-body col-md-12">
                            <div class="card-text row">
                                <h3 class="mb-3">Non ammortissable</h3>
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Terrain</mat-label>
                                        <input matInput [(ngModel)]="user.part_field"
                                               (ngModelChange)="edit($event)">
                                        <span matSuffix> %</span>
                                    </mat-form-field>
                                </div>

                                <h3 class="mb-3">Ammortissable</h3>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Meubles</mat-label>
                                                <input matInput disabled value="Réel">
                                                <span matSuffix> €</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input matInput
                                                       [(ngModel)]="user.amort_duration_furniture"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Frais d'agence</mat-label>
                                                <input matInput disabled value="Réel">
                                                <span matSuffix> €</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input matInput
                                                       [(ngModel)]="user.amort_duration_agency_fees"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Gros œuvre</mat-label>
                                                <input matInput [(ngModel)]="user.part_structure"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> %</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input matInput
                                                       [(ngModel)]="user.amort_duration_structure"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Equipements</mat-label>
                                                <input matInput [(ngModel)]="user.part_equipment"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> %</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input matInput
                                                       [(ngModel)]="user.amort_duration_equipment"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Travaux</mat-label>
                                                <input matInput disabled value="Réel">
                                                <span matSuffix> €</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input matInput [(ngModel)]="user.amort_duration_work"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Façades et étanchéité</mat-label>
                                                <input matInput [(ngModel)]="user.part_facade"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> %</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input matInput [(ngModel)]="user.amort_duration_facade"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Agencements</mat-label>
                                                <input matInput [(ngModel)]="user.part_arrangment"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> %</span>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Durée</mat-label>
                                                <input matInput
                                                       [(ngModel)]="user.amort_duration_arrangment"
                                                       (ngModelChange)="edit($event)">
                                                <span matSuffix> ans</span>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Onboarding -->
<joyrideStep [stepContent]="introStepContent"
             joyrideStep="introStep"
             stepPosition="center">
</joyrideStep>
<ng-template #introStepContent>
    <div class="user_onboarding_content">
        <h2>Personnaliser vos préférences</h2>
        <p>
            Félicitations, vous arrivez au bout des 9 étapes pour démarrer avec LyBox !<br/>
            <br/>
            Vous êtes bientôt un expert de l’application, et en tant qu’expert, vous allez pouvoir paramétrer LyBox
            pour qu’il s’adapte à votre stratégie d’investissement !
        </p>
    </div>
</ng-template>

<ng-template #userDefaultStepContent>
    <div class="user_onboarding_content">
        <h2>Personnaliser vos préférences</h2>
        <p>
            Vous pouvez ici choisir <b>les frais de gestion</b> par agence et de <b>Garantie Loyer Impayés</b>
            (GLI).<br/>
            Ces valeurs seront utilisées automatiquement pour calculer le <b>rendement net</b> de chaque annonce
            dans vos recherches.<br/>
            <br/>
            Vous pouvez aussi choisir <b>les ratios de prix/m² de travaux</b> pour faire des estimations rapides !
        </p>
    </div>
</ng-template>

<ng-template #userFinanceStepContent>
    <div class="user_onboarding_content">
        <h2>Personnaliser vos préférences</h2>
        <p>
            Place au <b>financement</b> !<br/>
            <br/>
            Renseignez ici <b>l’apport</b> que vous voulez mettre sur chaque projet, mais aussi la <b>durée</b> et
            le <b>taux de votre crédit</b>.<br/>
            <br/>
            Ces valeurs seront utilisées automatiquement pour calculer le <b>cash-flow</b> de chaque annonce dans
            vos recherches.
        </p>
    </div>
</ng-template>

<ng-template #userFiscaStepContent>
    <div class="user_onboarding_content">
        <h2>Personnaliser vos préférences</h2>
        <p>
            Maintenant, la fiscalité<br/>
            <br/>
            Vous pouvez renseigner le <b>régime fiscal</b> à utiliser par défaut, ainsi que vos informations
            personnelles pour que nous puissions calculer votre fiscalité.<br/>
            <br/>
            Le régime fiscal sera toujours modifiable dans vos simulations
        </p>
    </div>
</ng-template>

<ng-template #userAmmortStepContent>
    <div class="user_onboarding_content">
        <h2>Personnaliser vos préférences</h2>
        <p>
            Dans le cadre du <b>LMNP</b> ou de la <b>SCI à l’IS</b>, vous allez pratiquer des <b>amortissements
            comptables</b> pour calculer le montant des impôts sur votre projet.<br/>
            <br/>
            Les durées et les montants de chacun de ces amortissements sont modifiables ici.<br/>
            <br/>
            Les valeurs par défaut sont celles utilisées par la plupart des comptables, donc vous pouvez aussi
            laisser ces valeurs 🙂<br/>
        </p>
    </div>
</ng-template>
